import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cw-pause",
  "use": "icon-cw-pause-usage",
  "viewBox": "0 0 16 20",
  "content": "<symbol viewBox=\"0 0 16 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cw-pause\">\n<path d=\"M10.6667 19.3334V0.666687H16V19.3334H10.6667ZM0 19.3334V0.666687H5.33333V19.3334H0Z\" fill=\"#BABABA\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/cw-pause.svg
// module id = 122
// module chunks = 0 1 2